// src/components/RegModalButtons.js
import React, { useEffect, useState } from 'react';

import ModalForm from './ModalForm';
import UpdateModal from './UpdateModal';
import BackButton from './BackButton';

const RegModalButtons = ({ link, t, userId, token, userLevel }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentRoute, setCurrentRoute] = useState(null);

  const [isModalUpdateOpen, setIsModalUpdateOpen] = useState(false);
  const [updateId, setUpdateId] = useState(null);
  const [updateTable, setUpdateTable] = useState(null);
  const [updateRouteId, setUpdateRouteId] = useState(null);

  const openModal = (route) => {
    setCurrentRoute(route);
    setIsModalOpen(true);
  };

  const closeModal = () => setIsModalOpen(false);

  const openUpdateModal = (id, table, routeId) => {
    if (userLevel === 'developer') {
      setUpdateId(id);
      setUpdateTable(table);
      setUpdateRouteId(routeId);

      // setUpdateTable()
      setIsModalUpdateOpen(true);
    }
  };
  const closeUpdateModal = () => {
    setUpdateId(null);
    setIsModalUpdateOpen(false);
  };

  return (
    <>
      {updateId && (
        <UpdateModal
          userId={userId}
          token={token}
          table={updateTable}
          update_link_id={updateRouteId}
          id={updateId}
          isOpen={isModalUpdateOpen}
          onRequestClose={closeUpdateModal}
        />
      )}

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-start',
          flexWrap: 'wrap',
          gap: '10px',
          position: 'relative',
          padding: '10px',
        }}
      >
        {/* Buttons Group */}
        {link?.reg_route &&

          link.reg_route?.split(',').map((route, index) => {
            const name = link?.reg_name?.split(',')[index];
            const linkId = link?.reg_link_id?.split(',')[index];

            return (
              <div
                key={index}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <button
                  className="btn btn-primary"
                  onClick={() => openModal(route.trim())}
                >
                  {t(name)}
                </button>

                {userLevel === 'developer' && (
                  <span
                    style={{
                      color: 'blue',
                      fontSize: '0.9em',
                      marginTop: '4px',
                      cursor: 'pointer',
                    }}
                    onClick={() => openUpdateModal(linkId, 'ktc_link', 7)}
                    title={`Double click to update/edit the ${t(name)} form`}
                  >
                    {t('Update')}
                  </span>
                )}
              </div>
            );
          })}

        {/* Back Button (Right Aligned on Same Line) */}
        <div
          style={{
            position: 'absolute',
            right: '20px',
            top: '20px',
          }}
        >
          <BackButton />
        </div>
      </div>

      {isModalOpen && currentRoute && (
        <ModalForm
          userId={userId}
          token={token}
          route={currentRoute} // Pass the dynamic route to the modal
          isOpen={isModalOpen}
          onRequestClose={closeModal}
        />
      )}
    </>
  );
};

export default RegModalButtons;
